import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../../cc-base.component';
import {QuartzCronComponent, Tab} from "@sbzen/ng-cron";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cc-cron-field[id][formRecord]',
  templateUrl: './cron-field.component.html',
  styleUrls: ['./cron-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CronFieldComponent extends CcBaseComponent {

  @Input()
  id: any;

  @Input()
  required: boolean;

  @Input()
  disabled: boolean;

  @Input()
  change: any;

  @Input()
  hidden: boolean;

  @Input()
  formRecord: any;
  @Output()
  formRecordChange = new EventEmitter<any>();

  cronFieldDialogVisible: boolean = false;
  cronFieldDialogValue: string = '';
  cronTabs: Tab[] = [Tab.SECONDS, Tab.MINUTES, Tab.HOURS, Tab.DAY, Tab.MONTH];

  @ViewChild('cronField')
  cronField: QuartzCronComponent;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private confirmationService: ConfirmationService) {
    super(cdref, messageService, translateService);
  }

  clearValue(): void {
    this.cronFieldDialogVisible = false;
    this.formRecord = '';
    this.formRecordChange.emit(this.formRecord);
  }

  showCronFieldDialog(): void {
    if(this.formRecord === undefined || this.formRecord === null || this.formRecord === '') {
      this.formRecord = '0 0 0 ? * *'
    }
    this.cronFieldDialogVisible = true;
    setTimeout(() => {
      this.cronFieldDialogValue = this.formRecord;
      this.cronField.tabs = this.cronTabs;
    });
  }

  saveCronFieldDialog(): void {
    this.cronFieldDialogVisible = false;
    this.formRecord = this.cronFieldDialogValue;
    this.cronFieldDialogValue = '';
    this.formRecordChange.emit(this.formRecord);
  }

  valueChanged() {
    if (this.cronFieldDialogValue) {
      const values = this.cronFieldDialogValue.split(' ');
      if (values && values.length > 5) {
        this.cronFieldDialogValue = values.slice(0, 6).join(' ');
      }
    }
  }
}

